module.exports = new __parcel__URL__("rhino.6dcdebb2.svg").toString();